import axios from 'axios';
import { getCookie } from '../utils/auth';

// Build Base URL
let BASE = process.env.REACT_APP_BACKEND_ROOT
        || process.env.REACT_APP_BACKEND_URL 
        || "http://localhost:5001";

BASE = BASE.replace(/\/+$/, "");

if (!BASE.endsWith("/api/v1")) {
  if (BASE.endsWith("/api")) {
    BASE = BASE + "/v1";
  } else {
    BASE = BASE + "/api/v1";
  }
}

// --------------------------------------------
// AUTH HEADER HELPERS
// --------------------------------------------

const getAuthHeaders = () => {
  const token = getCookie('auth_token');
  if (!token) throw new Error("Authentication required");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

const getMultipartHeaders = () => {
  const token = getCookie('auth_token');
  if (!token) throw new Error("Authentication required");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data", // Explicitly set for clarity, though axios handles it
    },
  };
};

export const studentDashboardApi = {
  
  // 1. Update Profile (Fixes 401 & 404)
  updateProfile: async (userId, formData) => {
    try {
      const url = `${BASE}/student/${userId}/profile`;
      console.log("📤 Updating Profile at:", url);
      
      // Ensure we are sending FormData
      const res = await axios.put(url, formData, getMultipartHeaders());
      return res.data;
    } catch (error) {
      console.error("❌ Profile Update Error:", error);
      throw error.response?.data || error;
    }
  },

  // 2. Get My Applications
  getMyApplications: async () => {
    try {
      const res = await axios.get(`${BASE}/applications/my-applications`, getAuthHeaders());
      return res.data;
    } catch (error) {
      console.error("❌ Fetch Applications Error:", error);
      throw error;
    }
  },

  // 3. Get Drafts
  getDrafts: async (userId) => {
    try {
      const res = await axios.get(`${BASE}/selections/draft/${userId}`, getAuthHeaders());
      return res.data;
    } catch (error) {
      console.error("❌ Fetch Drafts Error:", error);
      throw error;
    }
  },

  // 4. Delete Draft
  deleteDraft: async (draftId) => {
    try {
      const res = await axios.delete(`${BASE}/selections/draft/${draftId}`, getAuthHeaders());
      return res.data;
    } catch (error) {
      console.error("❌ Delete Draft Error:", error);
      throw error;
    }
  },

  // 5. Get Single Application (For View Mode)
  getApplicationById: async (appId) => {
    try {
      const res = await axios.get(`${BASE}/applications/${appId}`, getAuthHeaders());
      return res.data;
    } catch (error) {
      console.error("❌ Get Application Error:", error);
      throw error;
    }
  }
};